import React from 'react';
import './App.css';
import Quote from './components/Quote';

function App() {
  return (
    <div className="App">
     <Quote />
    </div>
  );
}

export default App;
